import moment from 'moment-timezone';

export function dateWithTime(date, time, endOfRange = false) {
    if (!date || !moment(date).isValid() || !/^([01]\d|2[0-3]):[0-5]\d$/.test(time || '')) return null;
    const [hour, minute] = time.split(':').map(Number);
    return moment(date).startOf('day').set({hour, minute, second: endOfRange ? 59 : 0, millisecond: 0});
}

export function formatDateRange(start, end, startTime, endTime, endOfRange = true) {
    const from = dateWithTime(start, startTime);
    const to = dateWithTime(end, endTime, endOfRange);
    if (!from || !to || to.isBefore(from)) return null;
    return {from: from.format('YYYY-MM-DD HH:mm:ss'), to: to.format('YYYY-MM-DD HH:mm:ss')};
}
